import React, { useState } from "react"
import { InputAdornment } from "@mui/material"
import { EyeIcon, EyeSlashIcon } from "../../../../mp-core/icons"
import IconButton from "../IconButton"
import TextInput, { TextInputProps } from "../TextInput"

export type PasswordInputProps = Omit<TextInputProps, "inputType"> & {
  toggleAutomationId: string
}

// TextInput with a show/hide toggle; each field owns its own visibility state.
const PasswordInput = React.forwardRef<HTMLDivElement, PasswordInputProps>(
  ({ toggleAutomationId, inputProps = {}, InputProps = {}, ...rest }, ref) => {
    const [showPassword, setShowPassword] = useState(false)
    const toggleLabel = showPassword ? "Hide Password" : "Show Password"

    return (
      <TextInput
        ref={ref}
        {...rest}
        inputProps={{ ...inputProps, type: showPassword ? "text" : "password" }}
        InputProps={{
          ...InputProps,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                size="small"
                aria-label={toggleLabel}
                tooltipText={toggleLabel}
                data-automation-id={toggleAutomationId}
                onClick={() => setShowPassword(show => !show)}
                // Keep focus in the password field when toggling by mouse.
                onMouseDown={e => e.preventDefault()}
              >
                {showPassword ? <EyeSlashIcon /> : <EyeIcon />}
              </IconButton>
            </InputAdornment>
          )
        }}
      />
    )
  }
)

export default PasswordInput
